import PropTypes from 'prop-types';
import React from 'react';
import Image, { getVariantUrls } from '@fenderdigital/react-ui-kit/image';

const TablatureImage = ({ image }) => {
  if (!image) {
    return null;
  }
  const images = getVariantUrls(image, null);
  return (
    <div className="tablature-image dn db-l">
      <Image bgColor="transparent" images={images} />
    </div>
  );
};

TablatureImage.propTypes = {
  image: PropTypes.string,
};

TablatureImage.defaultProps = {
  image: '',
};

export default TablatureImage;
